import { createContext } from 'react'

const MandateWizardCtx = createContext()

export default MandateWizardCtx
